import LanguageObserver from 'language-observer';
import ResourceInjector from 'resource-injector';

const App = {
  languageObserver: null,

  initLanguageObserver() {
    this.languageObserver = new LanguageObserver();
    this.languageObserver.init();
  },

  async loadExternalResources() {
    const resourceInjector = new ResourceInjector();
    await resourceInjector.loadScript(
      '/common/scripts/signup-form.js',
      { defer: true },
      5000,
    );
  },

  async init() {
    await this.loadExternalResources();
    this.initLanguageObserver();
  },
};

document.addEventListener('DOMContentLoaded', () => App.init());
